import * as React from 'react';
import { SVGProps } from 'react';

const IconAddToComparisonSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1 1h2v14H1V1zm12 0h-2v2H9v2h2v2h2V5h2V3h-2V1zM7 5H5v10h2V5zm2 4h2v6H9V9zm6 2h-2v4h2v-4z" />
  </svg>
);
export default IconAddToComparisonSizeS;
